exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3LQG0{position:relative}._3LQG0 p{font-weight:300}._2gNZO{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;padding:40px 0;max-width:1000px;margin:0 auto}._1Mxyp{width:25%;padding:5px 1px}._18teB{padding:0 25px;width:100%}._1xf1K{font-size:17px;padding:10px 0;text-align:center}._1xf1K,._2RsEg{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._2RsEg{max-height:200px;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;width:100%}._2RsEg img{width:70px;height:70px;-o-object-fit:contain;object-fit:contain;padding:7px;border-radius:50%;cursor:pointer}@media (max-width:767px){._2gNZO{-ms-flex-wrap:wrap;flex-wrap:wrap;padding:20px 20px 30px}._1Mxyp{padding:20px 10px}._1xf1K{height:60px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._18teB{padding:0}}._3BySV{max-width:1300px;margin:0 auto}._128Hc{margin-bottom:40px;border:1px solid gray;height:320px;position:relative}._5OxYU{height:200px}.fd87n{font-weight:700;font-size:23px;padding:15px 15px 0;text-transform:uppercase}._1jOhr{padding:0 15px 15px;font-size:12px}._1kOuf{font-size:10px;position:absolute;bottom:16px;right:10px;text-align:right}._1kOuf a{padding:7px;font-size:13px;font-weight:700;color:#f5fffa}._1kOuf a:hover{color:#ffffe0}", ""]);

// exports
exports.locals = {
	"rowContainer": "_3LQG0",
	"topContainer": "_2gNZO",
	"iconBox": "_1Mxyp",
	"iconBoxBody": "_18teB",
	"iconBoxTitle": "_1xf1K",
	"iconBoxImageWrapper": "_2RsEg",
	"videosContainer": "_3BySV",
	"videoBox": "_128Hc",
	"youtube": "_5OxYU",
	"videoTitle": "fd87n",
	"videoDescription": "_1jOhr",
	"activityLink": "_1kOuf"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/routes/videos/Videos.css
// module id = 1344
// module chunks = 6